import BaseModel from '@/store/models/BaseModel';

export default class User extends BaseModel {}
